export const formatDate = (val: any) => {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'Europe/Berlin',
        // timeZoneName: 'short'
    };
    return new Date(parseInt(`${val}000`, 10)).toLocaleString('de-DE', options);
};

export const formatDateGerman = (val: any) => {
    const date = new Date(parseInt(`${val}000`, 10)); // Convert timestamp to Date object
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
    const year = date.getFullYear(); // Get full year

    return `${day}.${month}.${year}`; // Return in dd.mm.yyyy format
};

export const formatName = (firstName: string, lastName: string, full: boolean = true) => {
    if (full) {
        return `${firstName || ''} ${lastName || ''}`;
    }
    return `${(firstName || '').charAt(0)}. ${lastName || ''}`;
}